export const filterButtonStyle = {
    variant: 'outline',
};